/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `Step` - Step
 * * `Collapse` - Collapse
 */
export enum ViewTypeEnum {
    STEP = 'Step',
    COLLAPSE = 'Collapse',
}
